export default __webpack_public_path__ + "static/media/lgb-sunshine-cover.b5eb2ac3.jpg";